import { render, staticRenderFns } from "./actie.vue?vue&type=template&id=0f4c5ed2&"
import script from "./actie.vue?vue&type=script&lang=ts&"
export * from "./actie.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductSpecialNode: require('/home/vsts/work/1/a/NuxtApp/components/product/SpecialNode.vue').default})
